import React from "react";
import { AEInput } from "../../../_partials/controls";

const SearchFilter = ({
  mapPropsToFormik,
  field = "search",
  label = "SEARCH",
  classNames = ["col-lg-3"],
}) => {
  return (
    <div className={{ ...classNames }}>
      <AEInput {...mapPropsToFormik(field)} label={label} />
    </div>
  );
};

export default SearchFilter;
